import { Component } from 'react'
import { connect } from 'react-redux'
import { getCookie, setCookie } from '../../../cdl-react-components/utilities'
import { pushNotification } from '../../../../store/actions'

class CookieConsent extends Component {
    cookieName = 'CDDCookieConsent'

    render() { return null }

    componentDidMount() {
        if(!getCookie(this.cookieName))
            this.props.pushNotification(
                `This site requires the use of cookies to store state information.
                 <b>By continuing to use this website you consent to our use of cookies.</b>`,
                () => setCookie(this.cookieName))
    }
}

const mapDispatchToProps = (dispatch) => ({
    pushNotification: (message, callback) => dispatch(pushNotification(message, callback))
})

export default connect(null, mapDispatchToProps)(CookieConsent)
